/* eslint-disable func-names */
import { Instrumentation, SessionStorageAdapter } from '../types';

export default function (instrumentation?: Instrumentation): SessionStorageAdapter {
  const logError = function (error: Error) {
    if (instrumentation && instrumentation.logError) {
      instrumentation.logError(error.message);
    } else {
      console.error(error.message); // eslint-disable-line no-console
    }
  };

  const SessionStorage: SessionStorageAdapter = {
    supportsStorage() {
      return window && 'sessionStorage' in window && window.sessionStorage != null;
    },
    set(key: string, data: unknown) {
      const str = JSON.stringify(data);
      try {
        window.sessionStorage.setItem(key, str);
      } catch (err) {
        try {
          window.sessionStorage.clear();
          window.sessionStorage.setItem(key, str);
        } catch (innerErr) {
          logError(err as Error);
        }
      }
    },
    get<T = unknown>(key: string) {
      let result = null;
      try {
        const str = window.sessionStorage.getItem(key);
        if (str) {
          result = JSON.parse(str);
        }
      } catch (err) {
        logError(err as Error);
      }
      return result as T;
    },
    clear() {
      try {
        window.sessionStorage.clear();
      } catch (err) {
        logError(err as Error);
      }
    },
    invalidate(key: string) {
      try {
        window.sessionStorage.removeItem(key);
      } catch (err) {
        logError(err as Error);
      }
    },
    type: 'sessionStorage',
  };

  return SessionStorage;
}
